"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_LIMIT = void 0;
// 默认表格的行数
exports.PAGE_LIMIT = window.pageLimit || 1000;
